import {
    secureDelete,
    secureGet,
    securePost,
    securePut,
} from "../../Config/ApiConfig";

export const getAgents = async ({ page, size, search, filters, sort_by, sort_direction }) => {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("page_size", size);

    if (search && search.trim()) {
        params.append("search_string", search.trim());
    }

    if (filters && Object.keys(filters).length > 0) {
        params.append("filters", JSON.stringify(filters));
    }

    if (sort_by) {
        params.append("sort_by", String(sort_by));
    }
    if (sort_direction) {
        params.append("sort_direction", String(sort_direction));
    }

    const { data } = await secureGet(`/agents?${params.toString()}`);
    return data;
};

export const createOrUpdateAgent = async (body, id) => {
    const { data } = (id ? await securePut('/agents/' + id, body) : await securePost('/agents', body));
    return data;
};

export const deleteAgent = async (id) => {
    const { data } = await secureDelete('/agents/' + id);
    return data;
};

export const getPlatforms = async ({ page, size }) => {
    const { data } = await secureGet(`/auth-platforms/facebook_page/resources?sort_by=name&sort_direction=asc&page=${page}&page_size=${size}`);
    return data;
};

export const connectToAuth = async (access_token) => {
    const { data } = await securePost('/auth-platforms/facebook_page', { short_lived_token: access_token });
    return data;
};

export const getAgentContacts = async ({ id, page, size, search }) => {
    const { data } = await secureGet(`/agents/${id}/contacts?page=${page}&page_size=${size}&${search ? "&search_string=" + search : ''}`);
    return data;
};

/**
 * Beautify an agent system instruction.
 *
 * Backend endpoint (see API docs):
 *   POST /agents/beautify-system-instruction
 *
 * Expected request body:
 *   - draft_system_instruction: string (required)
 *   - agent_id?: string (optional, when beautifying an existing agent)
 */
export const beautifySystemInstruction = async (body) => {
    const { data } = await securePost('/agents/beautify-system-instruction', body);
    return data;
};

